module.exports = __webpack_public_path__ + "img/purchase.33eec5ea.svg";